import starFalling from "../../assets/img/star_falling.png";
import { useSiteData } from "../../contexts/SiteDataContext";
import { useLocale } from "../../i18n/LocaleContext";
import { useLocalized } from "../../i18n/localized";

const heroTextShadow =
  "[text-shadow:0_2px_16px_rgb(0_0_0_/_0.45),0_1px_3px_rgb(0_0_0_/_0.55)]";

/** Prefer a non-empty site text. Otherwise show the baked copy. */
function freshOrBaked(live: string, baked: string): string {
  return live.trim() ? live : baked;
}

interface MainPageHeroProps {
  onScrollToInfo: () => void;
}

function MainPageHero({ onScrollToInfo }: MainPageHeroProps) {
  const { siteData } = useSiteData();
  const { locale, t } = useLocale();
  const text = useLocalized();
  const heroTitle =
    locale === "ru"
      ? freshOrBaked(text(siteData?.main, "title"), t("hero.title"))
      : t("hero.title");
  const heroIntro = freshOrBaked(
    text(siteData?.main, "content"),
    t("hero.intro"),
  );
  const ratingLabel = freshOrBaked(
    text(siteData?.hero_rating_vpn, "title"),
    t("hero.rating"),
  );
  const criteriaLabel = freshOrBaked(
    text(siteData?.hero_eval_params, "title"),
    t("hero.criteria"),
  );

  return (
    <section className="w-full bg-dark text-white hero-bg-image overflow-hidden">
      <div className="relative container-lg 2xl:px-0 px-3 pt-[11.96875rem] lg:pt-[16.75rem] lg:pb-[23rem] pb-[11.96875rem]">
        <h1
          className={`text-[2rem] font-extrabold sm:text-[3rem] mb-3 md:mb-12 lg:text-[3.75rem] text-white lg:leading-[120%] lg:tracking-normal ${heroTextShadow}`}
        >
          {heroTitle}
        </h1>
        <div className="font-semibold max-w-[57.5rem] text-xl leading-[120%] md:text-[1.125rem] md:leading-[120%] mb-12">
          <div
            className={`ck-content text-white font-semibold leading-[120%] text-[1rem] md:text-[18px] md:tracking-[0.01em] paragraph-spacing ${heroTextShadow}`}
            dangerouslySetInnerHTML={{
              __html: heroIntro,
            }}
          />
        </div>

        <div className="flex flex-col gap-0 md:flex-row gap-6  lg:gap-12">
          <a
            href="/rating"
            data-umami-event="Main Page Hero Rating Click"
            className="button flex items-center justify-center rounded-lg text-center py-4 px-12 md:py-6 bg-yellow"
          >
            <span className="text-sm md:text-lg font-black">{ratingLabel}</span>
          </a>
          <button
            data-umami-event="Main Page Hero Parameters Click"
            onClick={onScrollToInfo}
            className="button flex items-center justify-center rounded-lg text-center py-4 px-12 md:py-6 bg-transparent border-[0.1875rem] border-yellow text-yellow"
          >
            <span className="text-sm md:text-lg font-black">
              {criteriaLabel}
            </span>
          </button>
        </div>

        <img
          src={starFalling}
          alt="Star Falling"
          loading="lazy"
          className="absolute top-[9.0625rem] right-[-20rem] max-w-[52.96875rem] hidden 2xl:block"
        />
      </div>
    </section>
  );
}

export default MainPageHero;
